import { withStyles } from '@mui/styles';

import SecretsModal from './secretsModal';
import { muiStyles } from './styles';

export default withStyles(muiStyles)(SecretsModal);